import React from "react";
import MarketingNav from "@/components/MarketingNav";
import QuoteCTA from "@/components/QuoteCTA";
import Seo from "@/components/Seo";
import SiteFooter from "@/components/SiteFooter";
import CustomerSubmissions from "@/components/CustomerSubmissions";
import GoogleReviews, { GoogleRatingBadge } from "@/components/GoogleReviews";
import { BIZ } from "@/data/site";
import { ExternalLink } from "lucide-react";

export default function ReviewsPage() {
  return (
    <div className="bg-paper min-h-screen">
      <Seo
        title="Customer Reviews"
        description={`Read verified customer reviews for Wynridge Exterior Cleaning in ${BIZ.city}, ${BIZ.stateShort} and share your own experience.`}
        path="/reviews/"
      />
      <MarketingNav />
      <QuoteCTA />

      <section className="pt-6 pb-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-700 mb-4">Reviews</div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-stone-900 leading-[1.05]" style={{ fontFamily: "Outfit" }}>
            What neighbors are<br /><span className="text-electric-500 italic">saying about us.</span>
          </h1>
          <p className="mt-6 text-lg text-stone-600 max-w-2xl">
            Real, verified reviews pulled live from our Google Business Profile — no invented testimonials, no filler. Loved the work? Leave one after your service.
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <a
              href={BIZ.gbpUrl}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="reviews-gbp-link"
              className="inline-flex items-center gap-2 rounded-full bg-brand-600 hover:bg-electric-500 text-white font-bold px-6 py-3 shadow-lg transition-all hover:-translate-y-0.5"
            >
              Review us on Google
              <ExternalLink className="w-4 h-4" />
            </a>
            <GoogleRatingBadge />
          </div>
        </div>
      </section>

      <GoogleReviews variant="light" />

      <CustomerSubmissions />
      <SiteFooter />
    </div>
  );
}
